import { Outlet } from "react-router-dom";
import { useState } from "react";
import "./procurement.css";

import ProcurementHeader from "./ProcurementHeader";
import ProcurementSidebar from "./ProcurementSidebar";
export default function Procurement() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="procurement-page">
      <ProcurementHeader onMenuClick={toggleSidebar} />{" "}
      {/* This is already correct */}
      <div className="procurement-body">
        <ProcurementSidebar isOpen={sidebarOpen} onClose={closeSidebar} />

        {sidebarOpen && (
          <div className="sidebar-overlay" onClick={closeSidebar}></div>
        )}

        <div className="procurement-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
